import { Link } from 'gatsby'

const go = (path: string) => {
  window.location.href = `\\${path}`
}

interface TryAureliusProps {
  blue?: boolean
}

const TryAurelius = ({ blue = false }: TryAureliusProps) => {
  return (
    <div className={`row middle-xs try ${blue ? 'feature-try' : ''}`}>
      <div className="col-xs-12 center-xs">
        <div className="try-line">
          <Link
            to="/free-trial"
            className={blue ? 'orange-link' : 'white-link'}
          >
            Try Aurelius for yourself
            <i
              className={`icon-right-arrow cta-arrow-icon ${
                blue ? 'feature-arrow-icon' : ''
              }`}
              role="button"
              tabIndex={0}
              onKeyDown={() => go('free-trial')}
              onClick={() => go('free-trial')}
            />
          </Link>
        </div>
        <p className={`cta-bar-subhead ${blue ? 'feature-try-subhead' : ''}`}>
          Sign up for a 30 day trial now
        </p>
      </div>
    </div>
  )
}

export default TryAurelius
